// extracted by mini-css-extract-plugin
export default {"forget-password-title":"forgetPassword_forget-password-title__4Luh4","forget-password-subtitle":"forgetPassword_forget-password-subtitle__WuE2g"};